import { render, staticRenderFns } from "./EstatusPagos.vue?vue&type=template&id=252bcd86&scoped=true"
import script from "./EstatusPagos.vue?vue&type=script&lang=js"
export * from "./EstatusPagos.vue?vue&type=script&lang=js"
import style0 from "./EstatusPagos.vue?vue&type=style&index=0&id=252bcd86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252bcd86",
  null
  
)

export default component.exports